import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { NamtechFooter } from "@/components/poc/NamtechFooter";
import { GoogleButton } from "@/components/auth/GoogleButton";
import { getInvite } from "@/lib/invite";

const InviteResume = () => {
  const inv = getInvite();
  if (!inv?.codigo) return <p data-testid="login-invite-only" className="text-xs text-center c-muted">CONECTA es solo por invitación. Pide una liga a un miembro.</p>;
  return (
    <Link to={`/i/${inv.codigo}/registro`} data-testid="login-resume-invite" className="block c-card p-3 text-sm text-center">
      Tienes una invitación. <span className="c-accent font-semibold">Terminar mi registro</span>
    </Link>
  );
};

export default function LoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
      nav("/", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen max-w-md mx-auto px-6 safe-top flex flex-col">
      <div className="flex-1 flex flex-col justify-center gap-10">
        <div className="space-y-4">
          <div className="w-14 h-14 rounded-2xl bg-[#0b2a47] flex items-center justify-center">
            <img src="/icons/icon-192.png" alt="CONECTA" width="56" height="56" className="w-14 h-14 rounded-2xl" />
          </div>
          <div>
            <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">CONECTA</h1>
            <p className="c-text-2 mt-1">Red de negocios e inversiones personales</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <label className="block space-y-1.5">
            <span className="text-xs font-mono uppercase tracking-widest c-muted">Usuario</span>
            <input data-testid="login-username-input" className="c-input" autoCapitalize="none" autoCorrect="off" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
          </label>
          <label className="block space-y-1.5">
            <span className="text-xs font-mono uppercase tracking-widest c-muted">Contraseña</span>
            <input data-testid="login-password-input" className="c-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          {error && <p data-testid="login-error" className="text-sm text-red-500">{error}</p>}
          <button data-testid="login-submit-button" disabled={busy} className="c-btn-primary w-full py-3.5 flex items-center justify-center gap-2 text-base">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Entrar
          </button>
        </form>
        <div className="space-y-3">
          <div className="flex items-center gap-3 text-xs c-muted"><span className="flex-1 border-t c-line" />o<span className="flex-1 border-t c-line" /></div>
          <GoogleButton />
          <InviteResume />
        </div>
      </div>
      <NamtechFooter />
    </div>
  );
}
